import * as React from 'react';

export function useStickyFiltersHeight(barRef: React.RefObject<HTMLElement>) {
  React.useEffect(() => {
    const bar = barRef.current
    const page = bar?.closest<HTMLElement>('.manage-activities-v2')
    if (!bar || !page || typeof ResizeObserver === 'undefined') { return }

    function publishHeight() { page.style.setProperty('--mav2-filters-height', `${bar.offsetHeight}px`) }

    const observer = new ResizeObserver(publishHeight)
    observer.observe(bar)
    return () => {
      observer.disconnect()
      page.style.removeProperty('--mav2-filters-height')
    }
  }, [barRef])
}
